<template>
  <div id="log-collection">
    <table class="unstriped hover scroll">
      <thead>
        <tr>
          <th>{{ 'Date'|t }} </th>
          <th>{{ 'Registrar'|t }} </th>
          <th>{{ 'Command'|t }} </th>
          <th>{{ 'Subject'|t }} </th>
          <th>{{ 'Result'|t }} </th>
          <th>{{ 'Message'|t }} </th>
          <th>{{ 'Duration'|t }} </th>
          <th>{{ 'Received'|t }} </th>
          <th>{{ 'Sent'|t }} </th>
          <th>{{ 'Session'|t }} </th>
          <th><span class="hover-help" :title="'Client Transaction ID'|t">clTRID</span></th>
        </tr>
      </thead>
      <tbody v-for="rec in records">
        <tr :key="rec.id" v-on:click.prevent="toggleDetail(rec.id)" :class="getRowClass(rec.code)">
          <td>{{ formatTimeStamp(rec.timestamp) }}</td>
          <td>{{ rec.registrar }}</td>
          <td>{{ rec.command }}</td>
          <td>{{ rec.object }}</td>
          <td><span class="hover-help" :title="decodeResponseCode(rec.code)">{{ rec.code }}</span></td>
          <td>{{ rec.message }}</td>
          <td><span class="hover-help" :title="formatMilliSeconds(rec.duration, false)">{{ formatMilliSeconds(rec.duration, true) }}</span></td>
          <td>{{ formatBytes(rec.request_size) }}</td>
          <td>{{ formatBytes(rec.response_size) }}</td>
          <td><span class="hover-help" :title="rec.session">{{ formatSession(rec.session) }}</span></td>
          <td>{{ rec.client_trid }}</td>
        </tr>
        <tr v-if="detail === rec.id" :key="rec.id + 'data'" v-on:click.prevent="toggleDetail(rec.id)" class="traffic-detail callout primary">
          <td colspan="6"><pre>{{ rec.request }}</pre></td>
          <td colspan="5"><pre>{{ rec.response }}</pre></td>
        </tr>
      </tbody>
      <tfoot>
      </tfoot>
    </table>
    <div class="expanded row">
      <div class="small-3 columns">{{ 'Total'|t }}: {{ total }}</div>
      <div class="small-7 columns"><Pager :total="totalPages" :current="page" v-on:pager-go="goToPage"></Pager></div>
      <div class="small-2 columns">
        <div class="input-group">
          <span class="input-group-label"><label for="limit" class="inline">{{ 'Limit'|t }}:</label></span>
          <select class="input-group-field" id="limit" :value="limit" v-on:change.stop="changeLimit">
            <option v-for="i in [15, 25, 50, 75, 100]" :key="i" :value="i">{{ i }}</option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Pager from '@/components/Pager';

  export default {
    name: 'AdminCollection',
    components: { Pager },
    data() {
      return {
        detail: null
      }
    },
    computed: {
      total() {
        return this.$store.getters['logs/getTotalLogs']
      },
      totalPages() {
        return Math.ceil(this.total / this.limit)
      },
      limit() {
        return this.$store.getters['logs/getActiveLimit']
      },
      records() {
        return this.$store.getters['logs/getPageResults']
      },
      page() {
        return this.$store.getters['logs/getActivePage']
      },
    },
    methods: {
      goToPage(n) {
        this.$store.dispatch('logs/listLogs', {page: n, limit: this.limit})
      },
      changeLimit(event) {
        this.$store.dispatch('logs/listLogs', {page: 0, limit: parseInt(event.target.value)})
      },
      formatTimeStamp(s) {
        let e = new Date(s * 1000);
        return e.toLocaleString()
      },
      formatMilliSeconds(n, round) {
        if (n === 0) {
          return "0 ms"
        }

        if (n < 1000000) {
          if (round) {
            return Math.round((n / 1000) * 100) / 100 + " μs"
          } else {
            return (n / 1000) + " μs"
          }
        }

        if (round) {
          return Math.round((n / 1000000) * 100) / 100 + " ms"
        } else {
          return (n / 1000000) + " ms"
        }
      },
      formatBytes(n) {
        return Math.round((n / 1024) * 100) / 100 + " kB"
      },
      formatSession(s) {
        return s.split("-")[0]
      },
      decodeResponseCode(code) {
        let codes = {
          "1000": "Command completed successfully",
          "1001": "Command completed successfully; action pending",
          "1300": "Command completed successfully; no messages",
          "1301": "Command completed successfully; ack to dequeue",
          "1500": "Command completed successfully; ending session",
          "2000": "Unknown command",
          "2001": "Command syntax error",
          "2002": "Command use error",
          "2003": "Required parameter missing",
          "2004": "Parameter value range error",
          "2005": "Parameter value syntax error",
          "2100": "Unimplemented protocol version",
          "2101": "Unimplemented command",
          "2102": "Unimplemented option",
          "2103": "Unimplemented extension",
          "2104": "Billing failure",
          "2105": "Object is not eligible for renewal",
          "2106": "Object is not eligible for transfer",
          "2200": "Authentication error",
          "2201": "Authorization error",
          "2202": "Invalid authorization information",
          "2300": "Object pending transfer",
          "2301": "Object not pending transfer",
          "2302": "Object exists",
          "2303": "Object does not exist",
          "2304": "Object status prohibits operation",
          "2305": "Object association prohibits operation",
          "2306": "Parameter value policy error",
          "2307": "Unimplemented object service",
          "2308": "Data management policy violation",
          "2400": "Command failed",
          "2500": "Command failed; server closing connection",
          "2501": "Authentication error; server closing connection",
          "2502": "Session limit exceeded; server closing connection",
        };

        if (code in codes) {
          return codes[code]
        }

        return code
      },
      toggleDetail(n) {
        if (this.detail === n) {
          this.detail = null;
        } else {
          this.detail = n;
        }
      },
      getRowClass(code) {
        return code < 2000 ? '' : 'callout warning'
      }
    },
    created() {
      this.$store.dispatch('logs/listLogs', {page: 0, limit: 25})
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/log/AdminCollection.vue